import dayjs, { type Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

export const useDates = () => {
	function formatDate(date: Dayjs | string, format: string, timeZone?: string) {
		if (timeZone) {
			return dayjs.tz(dayjs.utc(date), timeZone).format(format);
		}
		return dayjs(date).format(format);
	}

	return { formatDate };
};
